import { render, staticRenderFns } from "./DataSourceForm.vue?vue&type=template&id=228d3835&"
import script from "./DataSourceForm.vue?vue&type=script&lang=js&"
export * from "./DataSourceForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('228d3835')) {
      api.createRecord('228d3835', component.options)
    } else {
      api.reload('228d3835', component.options)
    }
    module.hot.accept("./DataSourceForm.vue?vue&type=template&id=228d3835&", function () {
      api.rerender('228d3835', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/modules/DataSourceForm.vue"
export default component.exports